"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _isSsr = require("./isSsr");
var KONG_AUTH_TYPE = 'kong';
var MERCURIO_AUTH_TYPE = 'mercurio';
var PRODUCTION_ENV = 'production';
var Env = {
  OVERRIDABLE_KEYS: ['AuthType', 'MercurioBaseUrl', 'SellerId', 'BuyerId', 'ListId'],
  isProduction: function isProduction() {
    return "production" === PRODUCTION_ENV;
  },
  isAuthTypeKong: function isAuthTypeKong() {
    switch (this.getAuthType()) {
      case KONG_AUTH_TYPE:
        return true;
      case MERCURIO_AUTH_TYPE:
        return false;
      default:
        return true;
    }
  },
  getUserId: function getUserId(userId) {
    return userId;
  },
  getAuthType: function getAuthType() {
    return this.getDefaultAuthType();
  },
  getDefaultAuthType: function getDefaultAuthType() {
    return "kong" || KONG_AUTH_TYPE;
  },
  getMercurioBaseUrl: function getMercurioBaseUrl() {
    return this.getDefaultMercurioBaseUrl();
  },
  getDefaultMercurioBaseUrl: function getDefaultMercurioBaseUrl() {
    return "wss://chatmercurio.olx.com.br/websocket";
  },
  getGraphqlUrl: function getGraphqlUrl() {
    return "https://chat-bff.olx.com.br/graphql";
  },
  accountEndpoint: function accountEndpoint() {
    return "https://apigw.olx.com.br/v1/sigyn/activity";
  },
  accountHeaderKey: function accountHeaderKey() {
    return "secret";
  },
  accountHeaderValue: function accountHeaderValue() {
    return "WO4wq18ZEbjMThbIWidG9OMFMVMHRhAc";
  },
  accountInterval: function accountInterval() {
    return "1800000";
  },
  meEndpoint: function meEndpoint() {
    return "https://apigw.olx.com.br/v3/me?X-OLX-TEAM-KEY=hQIPDF7Bfpw2WJUDwr9GV21jIoDSEJGl";
  }
};

// Stuff that should only be available for non-production environment
if (!Env.isProduction()) {
  Object.assign(Env, {
    getAuthType: function getAuthType() {
      return this.getOverride('AuthType') || this.getDefaultAuthType();
    },
    getMercurioBaseUrl: function getMercurioBaseUrl() {
      return this.getOverride('MercurioBaseUrl') || this.getDefaultMercurioBaseUrl();
    },
    getOverride: function getOverride(key) {
      return (0, _isSsr.isCsr)() && localStorage.getItem("override-".concat(key));
    },
    setOverride: function setOverride(key, val) {
      localStorage.setItem("override-".concat(key), val);
    },
    resetOverrides: function resetOverrides() {
      this.OVERRIDABLE_KEYS.forEach(function (key) {
        localStorage.removeItem("override-".concat(key));
      });
    },
    getUserId: function getUserId(userId) {
      return userId || this.getBuyerId();
    },
    getSellerId: function getSellerId() {
      return this.getOverride('SellerId') || this.getDefaultSellerId();
    },
    getBuyerId: function getBuyerId() {
      return this.getOverride('BuyerId') || this.getDefaultBuyerId();
    },
    getListId: function getListId() {
      return this.getOverride('ListId') || this.getDefaultListId();
    },
    getDefaultSellerId: function getDefaultSellerId() {
      return "";
    },
    getDefaultBuyerId: function getDefaultBuyerId() {
      return "";
    },
    getDefaultListId: function getDefaultListId() {
      return "";
    }
  });
}
var _default = exports["default"] = Env;